import type {
  PublicHoliday,
  PublicHolidayCreate,
  PublicHolidayUpdate,
} from '@lms/shared-types'
import { apiRequest } from './client'

export function listPublicHolidays(): Promise<PublicHoliday[]> {
  return apiRequest<PublicHoliday[]>('/api/v1/public-holidays')
}

export function listAdminPublicHolidays(): Promise<PublicHoliday[]> {
  return apiRequest<PublicHoliday[]>('/api/v1/admin/public-holidays')
}

export function createPublicHoliday(
  body: PublicHolidayCreate,
): Promise<PublicHoliday> {
  return apiRequest<PublicHoliday>('/api/v1/admin/public-holidays', {
    method: 'POST',
    body,
  })
}

function compositeKeyPath(date: string, region: string): string {
  return `/api/v1/admin/public-holidays/${encodeURIComponent(
    date,
  )}/${encodeURIComponent(region)}`
}

export function updatePublicHoliday(
  date: string,
  region: string,
  body: PublicHolidayUpdate,
): Promise<PublicHoliday> {
  return apiRequest<PublicHoliday>(compositeKeyPath(date, region), {
    method: 'PATCH',
    body,
  })
}

export function deletePublicHoliday(
  date: string,
  region: string,
): Promise<void> {
  return apiRequest<void>(compositeKeyPath(date, region), {
    method: 'DELETE',
  })
}
